
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/x/react-date-pickers/custom-opening-button",
      function () {
        return require("private-next-pages/x/react-date-pickers/custom-opening-button.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/x/react-date-pickers/custom-opening-button"])
      });
    }
  